export type TechnicalServiceCategoryKey =
  | 'TECHNICAL_SERVICE'
  | 'PROPERTY_MANAGEMENT'
  | 'OTHER_SERVICES'
  | 'GENERAL_SERVICE_CONTACTS';

export type TechnicalServiceCategoryOrder = TechnicalServiceCategoryKey[];

export const TECHNICAL_SERVICE_CATEGORY_KEYS: Record<TechnicalServiceCategoryKey, TechnicalServiceCategoryKey> = {
  TECHNICAL_SERVICE: 'TECHNICAL_SERVICE',
  PROPERTY_MANAGEMENT: 'PROPERTY_MANAGEMENT',
  OTHER_SERVICES: 'OTHER_SERVICES',
  GENERAL_SERVICE_CONTACTS: 'GENERAL_SERVICE_CONTACTS'
};

export const TECHNICAL_SERVICE_CATEGORY_ORDER: TechnicalServiceCategoryKey[] = [
  TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  TECHNICAL_SERVICE_CATEGORY_KEYS.PROPERTY_MANAGEMENT,
  TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS
];

export const createDefaultTechnicalServiceCategoryOrder = (): TechnicalServiceCategoryOrder => [
  ...TECHNICAL_SERVICE_CATEGORY_ORDER
];

export const SERVICE_TYPE_CATEGORY_MAP: Record<string, TechnicalServiceCategoryKey> = {
  'Heating': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Sanitary': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Electrical': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Smoke Detector': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Elevator': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Garage Door': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Pipe Blockage': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Pipe Burst & Water Damage': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Cable Television': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Lifting Systems and Pumps': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Electric Storage Heater': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Double Parker': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Gate/Gate Systems': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Sewer/Blockage': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Solar System/PVA': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Ventilation': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Apartment Transfer Station (DHW/Heating)': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Smoke and Heat Extraction System': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Fire Extinguisher': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Fire Doors': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Fire Alarm System': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Rauchwarnmelder': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Nachtspeicherofen': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Aufzug': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Elektrik': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Garagentor': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Hebeanlagen und Pumpen': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Heizung': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Kabelfernsehen': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Rohrverstopfung': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Sanitär': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Doppelparker': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Tore/Toranlagen': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Kanal-/verstopfung': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Solaranlage/PVA': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Lüftung': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Wohnungsübergabestation (WW/ Hzg)': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Rauch- und Wärmeabzugsanlage': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Feuerlöscher': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Brandschutztüren': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'Brandmeldeanlage': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,

  'Winter Service': TECHNICAL_SERVICE_CATEGORY_KEYS.PROPERTY_MANAGEMENT,
  'Stairwell Cleaning': TECHNICAL_SERVICE_CATEGORY_KEYS.PROPERTY_MANAGEMENT,
  'Garden Maintenance': TECHNICAL_SERVICE_CATEGORY_KEYS.PROPERTY_MANAGEMENT,
  'Green Roof Maintenance': TECHNICAL_SERVICE_CATEGORY_KEYS.PROPERTY_MANAGEMENT,
  'Green Pruning': TECHNICAL_SERVICE_CATEGORY_KEYS.PROPERTY_MANAGEMENT,
  'Treppenhausreinigung': TECHNICAL_SERVICE_CATEGORY_KEYS.PROPERTY_MANAGEMENT,
  'Gartenpflege': TECHNICAL_SERVICE_CATEGORY_KEYS.PROPERTY_MANAGEMENT,
  'Winterdienst': TECHNICAL_SERVICE_CATEGORY_KEYS.PROPERTY_MANAGEMENT,
  'Grünschnitt': TECHNICAL_SERVICE_CATEGORY_KEYS.PROPERTY_MANAGEMENT,

  'Meter Reading Service': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Locksmith Service': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Chimney Sweep': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Pest Control': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Energy Supply': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Building Insurance': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Heating Oil Supply': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'District Heating Supplier': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Locking System Maintenance': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Rental Mat Service': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Heating Cost Allocator': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'WE Meter': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Coating (UG)': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Windows': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Roller Shutter/Raffstore': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Doors': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Roofer': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Ablesedienst': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Schlüsseldienst': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Schornsteinfeger': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Schädlingsbekämpfung': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Energieversorgung': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Gebäudeversicherung': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Fernwärmeversorger': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Gründachpflege': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Heizölversorgung': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Mietmattenservice': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Schließanlage': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Heizkostenabrechner': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'WE-Zähler': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Beschichtung (TG)': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Fenster': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Rollo/Raffstore': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Türen': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Dachdecker': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Fiber / Internet': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Local Heating Supplier': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Glasfaser / Internet': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'Nahwärmeversorger': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,

  'Bulk Waste Collection': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Gas Supply/Emergency Service': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Power Supply/Emergency Service': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Water Supply': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Police': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Waste Disposal': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Gas Emergency/Gas Odor': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Recyclable Waste Disposal': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Street and Sidewalk Cleaning': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Property Developer': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Abfallentsorgung': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Sperrmüllabholung': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Straßen- und Gehwegreinigung': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Stromversorger/Störungsdienst': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Wasserversorgung': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Wertstoffentsorgung': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Gas-Notdienst/Gasgeruch': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Gasversorgung/Störungsdienst': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'Bauträger': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS
};

export interface TechnicalServiceCategoryDto {
  key: string;
  types: string[];
}

export interface TechnicalServiceCategoriesResponse {
  categories?: TechnicalServiceCategoryDto[];
}

export type TechnicalServiceTypeOrder = Record<TechnicalServiceCategoryKey, string[]>;
export type TechnicalServiceHeaderOrder = Record<TechnicalServiceCategoryKey, string[]>;

const CATEGORY_KEY_ALIASES: Record<string, TechnicalServiceCategoryKey> = {
  TECHNICAL_SERVICE: TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  TECHNICAL_SERVICES: TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  'TECHNICAL SERVICE': TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE,
  PROPERTY_MANAGEMENT: TECHNICAL_SERVICE_CATEGORY_KEYS.PROPERTY_MANAGEMENT,
  FACILITY_CARE: TECHNICAL_SERVICE_CATEGORY_KEYS.PROPERTY_MANAGEMENT,
  'PROPERTY MANAGEMENT / FACILITY CARE': TECHNICAL_SERVICE_CATEGORY_KEYS.PROPERTY_MANAGEMENT,
  OTHER_SERVICES: TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  MISCELLANEOUS_SERVICES: TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  'OTHER SERVICES / MISCELLANEOUS SERVICES': TECHNICAL_SERVICE_CATEGORY_KEYS.OTHER_SERVICES,
  GENERAL_SERVICE_CONTACTS: TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  EMERGENCY_SERVICES: TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS,
  'GENERAL SERVICE CONTACTS & EMERGENCY SERVICES': TECHNICAL_SERVICE_CATEGORY_KEYS.GENERAL_SERVICE_CONTACTS
};

const normalizeStringKey = (value: string | null | undefined): string =>
  (value || '')
    .toString()
    .trim()
    .toUpperCase()
    .replace(/[^A-Z]+/g, '_');

export const createEmptyTechnicalServiceOrder = (): TechnicalServiceTypeOrder => ({
  TECHNICAL_SERVICE: [],
  PROPERTY_MANAGEMENT: [],
  OTHER_SERVICES: [],
  GENERAL_SERVICE_CONTACTS: []
});

export const createEmptyTechnicalServiceHeaderOrder = (): TechnicalServiceHeaderOrder => ({
  TECHNICAL_SERVICE: [],
  PROPERTY_MANAGEMENT: [],
  OTHER_SERVICES: [],
  GENERAL_SERVICE_CONTACTS: []
});

export const normalizeTechnicalServiceCategoryKey = (
  value: string | null | undefined
): TechnicalServiceCategoryKey | null => {
  if (!value) {
    return null;
  }

  const direct = value.toString().trim().toUpperCase() as TechnicalServiceCategoryKey;
  if (TECHNICAL_SERVICE_CATEGORY_ORDER.includes(direct)) {
    return direct;
  }

  const normalized = normalizeStringKey(value) as TechnicalServiceCategoryKey;
  if (TECHNICAL_SERVICE_CATEGORY_ORDER.includes(normalized)) {
    return normalized;
  }

  if (CATEGORY_KEY_ALIASES[direct]) {
    return CATEGORY_KEY_ALIASES[direct];
  }

  if (CATEGORY_KEY_ALIASES[normalized]) {
    return CATEGORY_KEY_ALIASES[normalized];
  }

  return null;
};

export const getCategoryForServiceType = (serviceType: string | null | undefined): TechnicalServiceCategoryKey => {
  const normalized = (serviceType || '').trim();
  if (!normalized) {
    return TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE;
  }
  return SERVICE_TYPE_CATEGORY_MAP[normalized] || TECHNICAL_SERVICE_CATEGORY_KEYS.TECHNICAL_SERVICE;
};

export const normalizeTechnicalServiceCategoryOrder = (
  order: Iterable<string> | null | undefined
): TechnicalServiceCategoryOrder => {
  const normalized: TechnicalServiceCategoryOrder = [];
  const seen = new Set<TechnicalServiceCategoryKey>();

  Array.from(order || []).forEach((value) => {
    const categoryKey = normalizeTechnicalServiceCategoryKey(value);
    if (!categoryKey || seen.has(categoryKey)) {
      return;
    }
    seen.add(categoryKey);
    normalized.push(categoryKey);
  });

  TECHNICAL_SERVICE_CATEGORY_ORDER.forEach((categoryKey) => {
    if (seen.has(categoryKey)) {
      return;
    }
    seen.add(categoryKey);
    normalized.push(categoryKey);
  });

  return normalized;
};

const buildHintMap = (
  hints?: Map<string, TechnicalServiceCategoryKey> | Record<string, TechnicalServiceCategoryKey> | null
): Map<string, TechnicalServiceCategoryKey> => {
  if (!hints) {
    return new Map();
  }
  if (hints instanceof Map) {
    return new Map(hints);
  }
  const entries = Object.entries(hints)
    .filter(([key]) => typeof key === 'string')
    .map(([key, value]) => [key, value] as [string, TechnicalServiceCategoryKey]);
  return new Map(entries);
};

export const normalizeTechnicalServiceOrder = (
  order: any,
  serviceTypeCategoryHints?: Map<string, TechnicalServiceCategoryKey> | Record<string, TechnicalServiceCategoryKey>,
  availableServiceTypes?: Iterable<string>
): TechnicalServiceTypeOrder => {
  const base = createEmptyTechnicalServiceOrder();
  const seen = new Set<string>();
  const hintsMap = buildHintMap(serviceTypeCategoryHints);

  const resolveCategory = (type: string, explicit?: string | null): TechnicalServiceCategoryKey => {
    const explicitKey = normalizeTechnicalServiceCategoryKey(explicit || undefined);
    if (explicitKey) {
      return explicitKey;
    }
    const hintKey = hintsMap.get(type);
    if (hintKey) {
      const normalizedHint = normalizeTechnicalServiceCategoryKey(hintKey);
      if (normalizedHint) {
        return normalizedHint;
      }
    }
    return getCategoryForServiceType(type);
  };

  const addType = (rawType: unknown, categoryHint?: string | null): void => {
    if (typeof rawType !== 'string') {
      return;
    }
    const type = rawType.trim();
    if (!type || seen.has(type)) {
      return;
    }

    const category = resolveCategory(type, categoryHint);
    if (!base[category]) {
      return;
    }

    base[category].push(type);
    seen.add(type);
  };

  if (order && typeof order === 'object' && !Array.isArray(order)) {
    Object.entries(order).forEach(([key, value]) => {
      if (!Array.isArray(value)) {
        return;
      }
      value.forEach((type) => addType(type, key));
    });
  } else if (Array.isArray(order)) {
    order.forEach((type) => addType(type));
  } else if (order && Array.isArray((order as TechnicalServiceCategoriesResponse).categories)) {
    (order as TechnicalServiceCategoriesResponse).categories!.forEach((category) => {
      category.types.forEach((type) => addType(type, category.key));
    });
  }

  const iterableTypes = availableServiceTypes
    ? Array.from(availableServiceTypes).filter((type): type is string => typeof type === 'string')
    : [];

  iterableTypes.forEach((type) => addType(type));

  return base;
};

export const flattenTechnicalServiceOrder = (
  order: TechnicalServiceTypeOrder | undefined | null,
  categoryOrder?: TechnicalServiceCategoryOrder | null
): string[] => {
  if (!order) {
    return [];
  }
  return normalizeTechnicalServiceCategoryOrder(categoryOrder).reduce<string[]>((acc, key) => {
    const values = Array.isArray(order[key]) ? order[key] : [];
    values.forEach((value) => {
      if (typeof value === 'string') {
        acc.push(value.trim());
      }
    });
    return acc;
  }, []);
};

export const cloneTechnicalServiceOrder = (order: TechnicalServiceTypeOrder): TechnicalServiceTypeOrder => {
  const clone = createEmptyTechnicalServiceOrder();
  TECHNICAL_SERVICE_CATEGORY_ORDER.forEach((key) => {
    clone[key] = Array.isArray(order[key]) ? [...order[key]] : [];
  });
  return clone;
};
